/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { MediaStrictHttpResponse } from '../../media-strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { SearchCategoryModel } from '../../models/search-category-model';

export interface SearchClientIdCategoriesLangugeIsoCodeGet$Plain$Params {
  clientId: string;
  langugeIsoCode: string;
}

export function searchClientIdCategoriesLangugeIsoCodeGet$Plain(http: HttpClient, rootUrl: string, params: SearchClientIdCategoriesLangugeIsoCodeGet$Plain$Params, context?: HttpContext): Observable<MediaStrictHttpResponse<Array<SearchCategoryModel>>> {
  const rb = new RequestBuilder(rootUrl, searchClientIdCategoriesLangugeIsoCodeGet$Plain.PATH, 'get');
  if (params) {
    rb.path('clientId', params.clientId, {});
    rb.path('langugeIsoCode', params.langugeIsoCode, {});
  }

  return http.request(
    rb.build({ responseType: 'text', accept: 'text/plain', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as MediaStrictHttpResponse<Array<SearchCategoryModel>>;
    })
  );
}

searchClientIdCategoriesLangugeIsoCodeGet$Plain.PATH = '/Search/{clientId}/Categories/{langugeIsoCode}';
